import { makeStyles, Typography, Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  headerContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '15px',
    boxShadow: '0px 3.5px 5.5px 0px rgba(0,0,0,0.02)',
    borderColor: '#E2E8F0',
    borderWidth: '1px',
    borderStyle: 'solid',
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(3),
  },
  logo: {
    height: 44,
    width: 'auto',
    display: 'block',
    marginBottom: theme.spacing(2),
  },
  welcomeTitle: {
    color: '#2D3748',
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.4,
    marginBottom: theme.spacing(2),
  },
  welcomeSubtitle: {
    color: '#A0AEC0',
    fontSize: '16px',
    lineHeight: 1.5,
    maxWidth: '700px',
  },
}));

interface HeaderSectionProps {
  title: string;
  subtitle: string;
  /** Optional logo shown above the title (e.g. the HTEC OneLoopAi black logo). */
  logo?: string;
  logoAlt?: string;
}

export const HeaderSection = ({
  title,
  subtitle,
  logo,
  logoAlt,
}: HeaderSectionProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.headerContainer}>
      {logo && (
        <img className={classes.logo} src={logo} alt={logoAlt ?? title} />
      )}
      <Typography className={classes.welcomeTitle}>{title}</Typography>
      <Typography className={classes.welcomeSubtitle}>{subtitle}</Typography>
    </Box>
  );
};
